<template>
  <v-row no-gutters>
    <v-col v-if="isFetched">
      <v-row no-gutters v-if="!layers.length">
        <v-col class="text--disabled text-subtitle-1 my-6 text-center">
          {{ $i18n.t('table.rziMonitoring.fito.layersEmpty') }}
        </v-col>
      </v-row>
      <v-row v-else no-gutters>
        <v-expansion-panels
          accordion
          multiple
          focusable
          class="fito-layers-list my-6 mx-6"
          style="width: 100%; min-width: 0"
        >
          <template v-for="(layer, index) in layers">
            <v-expansion-panel :key="index" class="fito-layers-list-item" style="width: 100%">
              <v-expansion-panel-header class="text-left">
                <div class="d-flex justify-space-between align-center">
                  <span class="d-flex align-center" style="gap: 0.5rem">
                    <span class="font-weight-medium">{{ layer.title }}</span>
                    <span class="text-caption text--secondary">{{ layer.subtitle }}</span>
                  </span>
                  <span>
                    <div class="d-flex" style="gap: 0.5rem">
                      <span v-for="action in getActions(layer)" :key="action.name">
                        <v-tooltip bottom color="font">
                          <template #activator="{ on }">
                            <v-icon v-on="{ ...on, ...action.listeners }" @click.stop="action.trigger(layer)">{{
                              action.icon
                            }}</v-icon>
                          </template>
                          {{ action.tooltip }}
                        </v-tooltip>
                      </span>
                    </div>
                  </span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="species-panel">
                <rzi-fito-species :current-metadata="currentMetadata" :fito-layer-id="layer.feature.id" />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-divider v-if="index < layers.length - 1" :key="`divider-${index}`"></v-divider>
          </template>
        </v-expansion-panels>
      </v-row>
    </v-col>
    <v-col v-else class="my-6">
      <main-loader />
    </v-col>
  </v-row>
</template>

<script>
import { utils } from '@/mixins/rziHelpers';
import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';

import MainLoader from '@/components/MainLoader';
import RziFitoSpecies from '@/components/RziFitoSpecies';

export default {
  name: 'RziFitoLayers',
  mixins: [prepareAttributesFeatureCardMixin, utils],
  components: {
    MainLoader,
    RziFitoSpecies,
  },
  props: {
    currentMetadata: {
      type: Object,
      required: true,
    },
    parentFitoId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isFetched: false,
    layers: [],
  }),
  computed: {},
  methods: {
    editLayer(item) {
      this.$emit('openManageDialog', 'fitoLayers', this.parentFitoId, item.feature);
    },
    deleteLayer(item) {
      this.$emit('openDeleteDialog', 'fitoLayers', item.feature);
    },
    getActions() {
      return [
        {
          name: 'edit',
          icon: 'mdi-pencil',
          tooltip: this.$i18n.t('table.rziMonitoring.fito.editLayer'),
          trigger: this.editLayer,
        },
        {
          name: 'delete',
          icon: 'mdi-delete',
          tooltip: this.$i18n.t('table.rziMonitoring.fito.deleteLayer'),
          trigger: this.deleteLayer,
        },
      ];
    },
    async init() {
      try {
        const r = await this.getDataSourceFeatures({
          dataSource: this.currentMetadata.fitoLayers.datasource,
          filters: {
            $EQUAL: {
              [`${this.currentMetadata.fitoLayers.datasource}.${this.currentMetadata.fitoLayers.attributes.fito}`]: {
                value: this.parentFitoId,
              },
            },
          },
        });
        this.layers = r.features.map(item => ({
          feature: item,
          title: this.getAttributeTextValueByName(
            item.properties[this.currentMetadata.fitoLayers.attributes.layer],
            this.currentMetadata.fitoLayers.attributes.layer,
            this.currentMetadata.fitoLayers.datasource
          ),
          subtitle: `(${this.$i18n.t('table.rziMonitoring.fito.layerSubtitle', {
            coverage: item.properties[this.currentMetadata.fitoLayers.attributes.coverage],
            height: item.properties[this.currentMetadata.fitoLayers.attributes.height],
          })})`,
        }));
        this.isFetched = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
:deep(.fito-layers-list) {
  padding: 0;
  border-radius: 4px;
  @include border(all, 1px);
}
:deep(.fito-layers-list-item) {
  background-color: rgb(231, 231, 231, 0.5);
}
.species-panel :deep(.v-expansion-panel-content__wrap) {
  padding: 1.5rem !important;
  display: flex;
}
</style>
